import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {PopularSearchesProps} from './PopularSearchesProps.interface';

export function PopularSearches({
  children,
  className,
  ...props
}: PopularSearchesProps) {
  return (
    <div
      className={twMerge(
        'border-b border-solid border-theme-transparent-10',
        className
      )}
      {...props}
    >
      <Text className="font-medium2-bold block text-theme-solid-100">
        {t('search_trending')}
      </Text>
      <div className="mt-14pxr flex h-184pxr flex-col flex-wrap gap-y-16pxr">
        {children}
      </div>
    </div>
  );
}
